"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_native_1 = require("react-native");
function useAccessibilityInfo() {
    var _a = react_1.useState(false), reduceMotionEnabled = _a[0], setReduceMotionEnabled = _a[1];
    var _b = react_1.useState(false), screenReaderEnabled = _b[0], setScreenReaderEnabled = _b[1];
    var handleReduceMotionChanged = function (enabled) {
        return setReduceMotionEnabled(enabled);
    };
    var handleScreenReaderChanged = function (enabled) {
        return setScreenReaderEnabled(enabled);
    };
    react_1.useEffect(function () {
        react_native_1.AccessibilityInfo.isReduceMotionEnabled().then(handleReduceMotionChanged);
        react_native_1.AccessibilityInfo.isScreenReaderEnabled().then(handleScreenReaderChanged);
        react_native_1.AccessibilityInfo.addEventListener('reduceMotionChanged', handleReduceMotionChanged);
        react_native_1.AccessibilityInfo.addEventListener('screenReaderChanged', handleScreenReaderChanged);
        return function () {
            react_native_1.AccessibilityInfo.removeEventListener('reduceMotionChanged', handleReduceMotionChanged);
            react_native_1.AccessibilityInfo.removeEventListener('screenReaderChanged', handleScreenReaderChanged);
        };
    }, []);
    return { reduceMotionEnabled: reduceMotionEnabled, screenReaderEnabled: screenReaderEnabled };
}
exports.useAccessibilityInfo = useAccessibilityInfo;
//# sourceMappingURL=useAccessibilityInfo.js.map